module.exports = __webpack_public_path__ + "img/celular.5c2977e5.png";